import { Map } from 'immutable';
import { actionTypes } from './actions';

import initialState from './initialState';

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_INFO:
      return Map({
        loading: true,
        error: false,
        data: Map(),
      });
    case actionTypes.REQUEST_SUCCESS:
      return Map({
        error: null,
        loading: false,
        data: Map(action.payload),
      });
    case actionTypes.REQUEST_FAILURE:
      return Map({
        error: action.payload,
        loading: false,
        data: Map(),
      });
    case actionTypes.UPDATE_TAX_INFO: {
      return Map({
        error: null,
        loading: false,
        data: state.get('data').merge(action.payload),
      });
    }

    case actionTypes.CLOSE_WRITE_OFF_MESSAGE:
      return state.setIn(['data', action.payload], false);
    case actionTypes.RESET_IS_PRIMARY_PASSWORD:
      return state.setIn(['data', 'isPrimaryPassword'], false);
    default:
      return state;
  }
}
